import Base from './base'
import renderFields from './image-overlay-click.pug'

export default class ImageOverlayClick extends Base
  @label: "點擊地圖圖層"

  renderFields: renderFields
